function loadSubscriptionDropdown() {
  // alert("Got here");
  document
    .querySelectorAll(".variant-picker__options")
    .forEach(function (button) {
      button.addEventListener("click", function () {
        document.querySelectorAll(".spid-select").forEach(function (el) {
          el.addEventListener("click", function () {
            // alert(el.value);
            el.querySelector("data-spid-input").value = el.value;
          });
        });
      });
    });
}

window.onload = function () {
  loadSubscriptionDropdown();
};
